import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import { useParams } from 'react-router-dom'
import { BASE_URL, getNewList } from '../api/api'
import Pagination from './pagination'
import NavLink from './navLink'

const Yjbg = () => {
  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 20

  const [data, setData] = useState([])

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
    })
  }, [pagesize, channel_id, page])

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0" name="研究报告">
        <div className="w-full bg-cover mb-10 lg:mb-0 lg:px-0 mt-[60px]">
          <div className="flex justify-between flex-wrap">
            {data?.list?.data?.map(({ id, title, image = '', obj, description, outlink }) => (
              <NavLink isOutLink={!!outlink} to={outlink || `/wzxq/id/${id}`} key={id}>
                <div key={id} className="w-full lg:w-[280px] mt-9 p-2 bg-white">
                  <img src={`${BASE_URL}${image}`} style={{ height: 170 }} alt="" />
                  <p className="mt-4 text-[#333]">{obj}</p>
                  <p className="mt-4 text-[#333] line-clamp-1">{title}</p>
                  <p className="mt-4 text-sm text-[#555555] font-sourceHan leading-[28px] line-clamp-3">
                    {description}
                  </p>
                </div>
              </NavLink>
            ))}
            <div className="w-[280px]"></div>
            <div className="w-[280px]"></div>
          </div>
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default Yjbg
